import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { JOURNEY_NODES, JourneyNodeState, JourneyStep, journeyNodeState } from '../../data/journey-steps';

const CIRCLE: Record<JourneyNodeState, string> = {
  done: 'bg-journey-teal text-white',
  current: 'bg-journey-teal text-white ring-4 md:ring-[6px] ring-journey-teal-halo',
  pending: 'bg-white text-journey-teal border-2 border-journey-teal',
};

const STATE_LABEL: Record<JourneyNodeState, string> = {
  done: 'completado',
  current: 'paso actual',
  pending: 'pendiente',
};

/** Six-node progress bar of the origination journey (PDF 3.3); one row on every width. */
@Component({
  selector: 'app-journey-stepper',
  standalone: true,
  imports: [NgFor, NgIf, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <nav aria-label="Progreso de tu solicitud" class="w-full">
      <ol class="grid grid-cols-6">
        <li *ngFor="let label of nodes; let i = index" class="relative flex flex-col items-center text-center" [attr.data-state]="state(i + 1)" [attr.aria-current]="state(i + 1) === 'current' ? 'step' : null">
          <span *ngIf="i > 0" aria-hidden="true" class="absolute top-[13px] md:top-[19px] right-1/2 w-full h-0.5 bg-gray-300"></span>
          <span class="jstep-circle relative z-10 flex items-center justify-center rounded-full size-7 md:size-10 text-xs md:text-base font-bold" [ngClass]="circle(i + 1)">
            <svg *ngIf="state(i + 1) === 'done'; else number" class="jstep-check size-3.5 md:size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="5 12.5 10 17.5 19 7"></polyline></svg>
            <ng-template #number>{{ i + 1 }}</ng-template>
          </span>
          <span class="jstep-label mt-1.5 md:mt-2.5 px-0.5 text-[8.5px] min-[380px]:text-[9.5px] sm:text-xs md:text-sm leading-tight font-bold text-journey-teal">{{ label }}</span>
          <span class="sr-only">({{ stateLabel(i + 1) }})</span>
        </li>
      </ol>
    </nav>
  `,
})
export class JourneyStepperComponent {
  @Input({ required: true }) current!: JourneyStep;

  readonly nodes = JOURNEY_NODES;

  state(node: number): JourneyNodeState {
    return journeyNodeState(node, this.current);
  }

  circle(node: number): string {
    return CIRCLE[this.state(node)];
  }

  stateLabel(node: number): string {
    return STATE_LABEL[this.state(node)];
  }
}
